document.addEventListener('DOMContentLoaded', function() {
  tabs();
});

function tabs() {
  document.querySelectorAll('.pricing-nav-item').forEach(tab => {
    const tabId = tab.getAttribute('data-target');
    const correspondingTab = document.querySelector(`.div-pricing-tabs-item#${tabId}`);
    
    if (correspondingTab) {
      tab.addEventListener('click', () => {
        // Remove active class from all buttons and tabs
        document.querySelectorAll('.pricing-nav-item').forEach(btn => btn.classList.remove('active'));
        document.querySelectorAll('.div-pricing-tabs-item').forEach(item => item.classList.remove('active'));

        // Add active class to clicked button and corresponding tab
        correspondingTab.classList.add('active');
        tab.classList.add('active');
      });
    }
  });
  
  // Activate first tab by default
  const firstButton = document.querySelector('.pricing-nav-item');
  const firstTab = document.querySelector('.div-pricing-tabs-item');
  
  if (firstButton && firstTab) {
    firstButton.classList.add('active');
    firstTab.classList.add('active');
  }
}